<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" v-if="renderComp" />
    <v-dialog :model-value="EditTerritoryDialog" persistent width="500">
      <v-card tile elevation="0">
        <v-toolbar density="compact" elevation="0" color="primary" class="pl-2">
          {{ ActionObj.action == "EDIT" ? "EDIT" : "Delete" }}
          {{ ActionObj.pincode_territory_type }}
          <v-spacer />
          <v-btn
            size="small"
            variant="text"
            icon
            @click="EditTerritoriesEmit(1)"
          >
            <v-icon icon="mdi-close" />
          </v-btn>
        </v-toolbar>

        <v-form ref="forms">
          <v-text-field
            color="primary"
            v-if="ActionObj.action == 'EDIT'"
            density="compact"
            variant="outlined"
            label="Territory Type"
            v-model="Pincode_Territory_type"
            class="mx-4 mt-2"
          />

          <v-select
            color="primary"
            v-if="ActionObj.action == 'EDIT'"
            v-model="selection"
            :items="options"
            label="Select Option"
            density="compact"
            variant="outlined"
            class="mx-4"
          />

          <v-select
            color="primary"
            v-if="selection === 'Hours'"
            density="compact"
            variant="outlined"
            label="Hours"
            v-model="Time_Values"
            :items="TimeArray"
            class="mx-4"
          />

          <SwDatePickerField
                v-model="date"
                v-bind="FILTER_PANEL_CONTROL"
                :min="startDate"
                :max="endDate"
                hide-details
                label=""
                @apply="updateFormattedDay"
              />
        </v-form>

        <div
          align="center"
          v-if="ActionObj.action == 'DELETE'"
          class="mx-3 my-3"
        >
          Do you need to delete designation
          <span class="font-weight-bold text-red">
            {{ ActionObj.pincode_territory_type }}
          </span>
          ?
        </div>

        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            size="small"
            @click="EditTerritoriesEmit(1)"
            variant="flat"
            color="grey"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="ActionObj.action == 'EDIT'"
            size="small"
            color="primary"
            variant="flat"
            @click="editPinCodeMethod()"
            :loading="loading"
          >
            EDIT
          </v-btn>
          <v-btn
            v-if="ActionObj.action == 'DELETE'"
            size="small"
            color="red"
            variant="flat"
            @click="DeletePharmacyMethod()"
            :loading="loading"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { EditPincodeType } from "@/graphql/mutations.js";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import Snackbar from "@/components/Extras/SnackbarView.vue";

export default {
  props: {
    EditTerritoryDialog: Boolean,
    ActionObj: Object,
  },
  components: {
    Snackbar,
  },
  data: () => ({
    Pincode_Territory_type: "",
    loading: false,
    SnackBarComponent: {},
    Time_Values: "",
    Territory_Type: "",
    options: ["Hours", "Days"],
    selection: "",
    menu: false,
    date: null,
    baseDate: "2025-01-01",
    startDate: "2025-01-01",
    endDate: "2025-01-31",
    renderComp: true,
  }),
  computed: {
    TimeArray() {
      let Time_Value = [];
      for (let i = 1; i <= 24; i++) {
        Time_Value.push(`${i} Hour${i > 1 ? "s" : ""}`);
      }
      return Time_Value;
    },
    formattedDay() {
      if (!this.date) {
        return "";
      }

      try {
        // Parse dates correctly
        const start = new Date(this.startDate);
        const selected = new Date(this.date);

        // Ensure dates are valid
        if (isNaN(start.getTime()) || isNaN(selected.getTime())) {
          return "";
        }

        // Reset time parts to avoid timezone issues
        const startUTC = Date.UTC(
          start.getFullYear(),
          start.getMonth(),
          start.getDate()
        );
        const selectedUTC = Date.UTC(
          selected.getFullYear(),
          selected.getMonth(),
          selected.getDate()
        );

        // Calculate difference in days
        const diffTime = selectedUTC - startUTC;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

        // Ensure diffDays is a valid number
        if (isNaN(diffDays) || diffDays < 1) {
          return "";
        }

        return `${diffDays} Day${diffDays > 1 ? "s" : ""}`;
      } catch (error) {
        console.error("Error calculating day difference:", error);
        return "";
      }
    },
  },
  watch: {
    EditTerritoryDialog(val) {
      if (val == true) {
        
        this.Pincode_Territory_type =
          this.ActionObj.pincode_territory_type || "";
        this.selection = "";
        this.Time_Values = "";
        this.date = null;

        if (this.ActionObj.estimated_time) {
          if (this.ActionObj.estimated_time.includes("Days")) {
            this.selection = "Days";
            // Extract day count from existing value and calculate date
            const dayMatch = this.ActionObj.estimated_time.match(/(\d+)\s*Day/);
            if (dayMatch && dayMatch[1]) {
              const dayCount = parseInt(dayMatch[1]);
              if (!isNaN(dayCount) && dayCount > 0) {
                // Calculate date based on day count
                const start = new Date(this.startDate);
                const calculatedDate = new Date(start);
                calculatedDate.setDate(start.getDate() + dayCount - 1);

                // Format as YYYY-MM-DD
                const year = calculatedDate.getFullYear();
                const month = String(calculatedDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const day = String(calculatedDate.getDate()).padStart(2, "0");
                this.date = `${year}-${month}-${day}`;
              }
            }
          } else if (this.ActionObj.estimated_time.includes("Hours")) {
            this.selection = "Hours";
            this.Time_Values = this.ActionObj.estimated_time;
          }
        }
      } else {
        // Reset form when dialog closes
        this.Pincode_Territory_type = "";
        this.selection = "";
        this.Time_Values = "";
        this.date = null;
      }
    },
  },
  methods: {
    updateFormattedDay() {
      // This is handled by computed property
      this.menu = false;
    },
    EditTerritoriesEmit(Toggle) {
      if (this.$refs.forms) {
        this.$refs.forms.reset();
      }
      this.$emit("clicked", Toggle);
    },
    async editPinCodeMethod() {
      try {
        this.loading = true;

        // Validate required fields
        if (!this.Pincode_Territory_type.trim()) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            SnackbarText: "Territory Type is required",
            Top: true,
            timeout: 2000,
          };
          this.loading = false;
          return;
        }

        if (this.selection === "Days" && !this.date) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            SnackbarText: "Please select a date",
            Top: true,
            timeout: 2000,
          };
          this.loading = false;
          return;
        }

        if (this.selection === "Hours" && !this.Time_Values) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            SnackbarText: "Please select hours",
            Top: true,
            timeout: 2000,
          };
          this.loading = false;
          return;
        }

        var inputparams = {
          organization_id:
            this.$store.getters.get_current_user_details.organization_id,
          updater_user_id: this.$store.getters.get_current_user_details.user_id,
          pincode_id: this.ActionObj.pincode_id,
          pincode_territory_type: this.Pincode_Territory_type,
          estimated_time:
            this.selection == "Days" ? this.formattedDay : this.Time_Values,
        };

        let result = await client.graphql({
          query: EditPincodeType,
          variables: {
            input: inputparams,
          },
        });

        this.loading = false;
        var ResultObject = JSON.parse(result.data.EditPincodeType);
        if (ResultObject.status == "SUCCESS") {
          this.renderComp = false;
          this.$nextTick(() => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              SnackbarText: ResultObject.Status_Message,
            };
            this.renderComp = true;
          });
          this.EditTerritoriesEmit(2);
        }
      } catch (error) {
        this.loading = false;
        
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: error.errors?.[0]?.message || "An error occurred",
          Top: true,
          timeout: 2000,
        };
      }
    },
    DeletePharmacyMethod() {
      // Implement delete logic here
      this.loading = false;
      this.EditTerritoriesEmit(2);
    },
  },
};
</script>

<style scoped>
.text-red {
  color: #f44336;
}
</style>
